import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';
import styles from './ModalStores.module.css';
import Modal from '@/components/Modal/Modal';
import { Box } from '@mui/material';

export interface IAppProps {
  stores: string[] | undefined;
  isOpen: boolean;
  onClose: () => void;
}

const ModalStores = (props: IAppProps) => {
  const { isOpen, onClose, stores } = props;
  return (
    <Modal
      className={styles.modal}
      isOpen={isOpen}
      onClose={() => onClose()}
      bodyClass={styles.modalBodyOver}
      showTitleDivider
      headerContent={stores?.length === 1 ? `${stores?.length} Selected Store` : `${stores?.length} Selected Stores`}
      bodyContent={
        <Box p={3}>
          <div className={styles.body}>
            {stores?.map((storeNumber, idx) =>
              stores?.length === 1 || idx === stores.length - 1 ? `${storeNumber}` : `${storeNumber}, `,
            )}
          </div>
        </Box>
      }
      footerContent={
        <div className={styles.buttons}>
          <Button
            style={{ width: '12.5em', display: 'flex', justifyContent: 'center' }}
            variant={ButtonVariants.Primary}
            onClick={() => onClose()}
            type="button"
          >
            Close
          </Button>
        </div>
      }
    />
  );
};
export default ModalStores;
